import { UserService } from '@core/services/user.service';
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private userService: UserService,
  ) {}

  canActivate(): Observable<boolean> | UrlTree {
    return this.userService.isLoggedIn;
  }
}
